export class Menu {
  constructor({
    menuId = 0,
    icon = null,
    title = null,
    route = null,
    order = null,
    hasData = false,
  } = {}) {
    this.menuId = menuId;
    this.icon = icon;
    this.title = title;
    this.route = route;
    this.order = order;
    this.hasData = hasData;
  }
}

export function CreateNewMenu(data) {
  return Object.freeze(new Menu(data));
}
